/**
 * @fileoverview gRPC-Web generated client stub for events.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.33.4
// source: events/v1/event.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as events_v1_event_pb from '../../events/v1/event_pb'; // proto import: "events/v1/event.proto"
import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb'; // proto import: "google/protobuf/empty.proto"


export class EventServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListEvents = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/ListEvents',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.ListEventsRequest,
    events_v1_event_pb.ListEventsResponse,
    (request: events_v1_event_pb.ListEventsRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.ListEventsResponse.deserializeBinary
  );

  listEvents(
    request: events_v1_event_pb.ListEventsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.ListEventsResponse>;

  listEvents(
    request: events_v1_event_pb.ListEventsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.ListEventsResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.ListEventsResponse>;

  listEvents(
    request: events_v1_event_pb.ListEventsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.ListEventsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/ListEvents',
        request,
        metadata || {},
        this.methodDescriptorListEvents,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/ListEvents',
    request,
    metadata || {},
    this.methodDescriptorListEvents);
  }

  methodDescriptorGetEvent = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/GetEvent',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.GetEventRequest,
    events_v1_event_pb.Event,
    (request: events_v1_event_pb.GetEventRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.Event.deserializeBinary
  );

  getEvent(
    request: events_v1_event_pb.GetEventRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.Event>;

  getEvent(
    request: events_v1_event_pb.GetEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.Event) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.Event>;

  getEvent(
    request: events_v1_event_pb.GetEventRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.Event) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/GetEvent',
        request,
        metadata || {},
        this.methodDescriptorGetEvent,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/GetEvent',
    request,
    metadata || {},
    this.methodDescriptorGetEvent);
  }

  methodDescriptorCreateEvent = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/CreateEvent',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.CreateEventRequest,
    events_v1_event_pb.Event,
    (request: events_v1_event_pb.CreateEventRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.Event.deserializeBinary
  );

  createEvent(
    request: events_v1_event_pb.CreateEventRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.Event>;

  createEvent(
    request: events_v1_event_pb.CreateEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.Event) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.Event>;

  createEvent(
    request: events_v1_event_pb.CreateEventRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.Event) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/CreateEvent',
        request,
        metadata || {},
        this.methodDescriptorCreateEvent,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/CreateEvent',
    request,
    metadata || {},
    this.methodDescriptorCreateEvent);
  }

  methodDescriptorUpdateEvent = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/UpdateEvent',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.UpdateEventRequest,
    events_v1_event_pb.Event,
    (request: events_v1_event_pb.UpdateEventRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.Event.deserializeBinary
  );

  updateEvent(
    request: events_v1_event_pb.UpdateEventRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.Event>;

  updateEvent(
    request: events_v1_event_pb.UpdateEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.Event) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.Event>;

  updateEvent(
    request: events_v1_event_pb.UpdateEventRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.Event) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/UpdateEvent',
        request,
        metadata || {},
        this.methodDescriptorUpdateEvent,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/UpdateEvent',
    request,
    metadata || {},
    this.methodDescriptorUpdateEvent);
  }

  methodDescriptorDeleteEvent = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/DeleteEvent',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.DeleteEventRequest,
    google_protobuf_empty_pb.Empty,
    (request: events_v1_event_pb.DeleteEventRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteEvent(
    request: events_v1_event_pb.DeleteEventRequest,
    metadata?: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteEvent(
    request: events_v1_event_pb.DeleteEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteEvent(
    request: events_v1_event_pb.DeleteEventRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/DeleteEvent',
        request,
        metadata || {},
        this.methodDescriptorDeleteEvent,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/DeleteEvent',
    request,
    metadata || {},
    this.methodDescriptorDeleteEvent);
  }

  methodDescriptorLogin = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/Login',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.LoginRequest,
    events_v1_event_pb.LoginResponse,
    (request: events_v1_event_pb.LoginRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.LoginResponse.deserializeBinary
  );

  login(
    request: events_v1_event_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.LoginResponse>;

  login(
    request: events_v1_event_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.LoginResponse>;

  login(
    request: events_v1_event_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/Login',
        request,
        metadata || {},
        this.methodDescriptorLogin,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/Login',
    request,
    metadata || {},
    this.methodDescriptorLogin);
  }

  methodDescriptorListUsers = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/ListUsers',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.ListUsersRequest,
    events_v1_event_pb.ListUsersResponse,
    (request: events_v1_event_pb.ListUsersRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.ListUsersResponse.deserializeBinary
  );

  listUsers(
    request: events_v1_event_pb.ListUsersRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.ListUsersResponse>;

  listUsers(
    request: events_v1_event_pb.ListUsersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.ListUsersResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.ListUsersResponse>;

  listUsers(
    request: events_v1_event_pb.ListUsersRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.ListUsersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/ListUsers',
        request,
        metadata || {},
        this.methodDescriptorListUsers,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/ListUsers',
    request,
    metadata || {},
    this.methodDescriptorListUsers);
  }

  methodDescriptorGetUser = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/GetUser',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.GetUserRequest,
    events_v1_event_pb.User,
    (request: events_v1_event_pb.GetUserRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.User.deserializeBinary
  );

  getUser(
    request: events_v1_event_pb.GetUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.User>;

  getUser(
    request: events_v1_event_pb.GetUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.User) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.User>;

  getUser(
    request: events_v1_event_pb.GetUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.User) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/GetUser',
        request,
        metadata || {},
        this.methodDescriptorGetUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/GetUser',
    request,
    metadata || {},
    this.methodDescriptorGetUser);
  }

  methodDescriptorCreateUser = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/CreateUser',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.CreateUserRequest,
    events_v1_event_pb.User,
    (request: events_v1_event_pb.CreateUserRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.User.deserializeBinary
  );

  createUser(
    request: events_v1_event_pb.CreateUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.User>;

  createUser(
    request: events_v1_event_pb.CreateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.User) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.User>;

  createUser(
    request: events_v1_event_pb.CreateUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.User) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/CreateUser',
        request,
        metadata || {},
        this.methodDescriptorCreateUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/CreateUser',
    request,
    metadata || {},
    this.methodDescriptorCreateUser);
  }

  methodDescriptorUpdateUser = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/UpdateUser',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.UpdateUserRequest,
    events_v1_event_pb.User,
    (request: events_v1_event_pb.UpdateUserRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.User.deserializeBinary
  );

  updateUser(
    request: events_v1_event_pb.UpdateUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.User>;

  updateUser(
    request: events_v1_event_pb.UpdateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.User) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.User>;

  updateUser(
    request: events_v1_event_pb.UpdateUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.User) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/UpdateUser',
        request,
        metadata || {},
        this.methodDescriptorUpdateUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/UpdateUser',
    request,
    metadata || {},
    this.methodDescriptorUpdateUser);
  }

  methodDescriptorDeleteUser = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/DeleteUser',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.DeleteUserRequest,
    google_protobuf_empty_pb.Empty,
    (request: events_v1_event_pb.DeleteUserRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteUser(
    request: events_v1_event_pb.DeleteUserRequest,
    metadata?: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteUser(
    request: events_v1_event_pb.DeleteUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteUser(
    request: events_v1_event_pb.DeleteUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/DeleteUser',
        request,
        metadata || {},
        this.methodDescriptorDeleteUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/DeleteUser',
    request,
    metadata || {},
    this.methodDescriptorDeleteUser);
  }

  methodDescriptorRegisterForEvent = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/RegisterForEvent',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.RegisterForEventRequest,
    events_v1_event_pb.RegisterForEventResponse,
    (request: events_v1_event_pb.RegisterForEventRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.RegisterForEventResponse.deserializeBinary
  );

  registerForEvent(
    request: events_v1_event_pb.RegisterForEventRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.RegisterForEventResponse>;

  registerForEvent(
    request: events_v1_event_pb.RegisterForEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.RegisterForEventResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.RegisterForEventResponse>;

  registerForEvent(
    request: events_v1_event_pb.RegisterForEventRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.RegisterForEventResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/RegisterForEvent',
        request,
        metadata || {},
        this.methodDescriptorRegisterForEvent,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/RegisterForEvent',
    request,
    metadata || {},
    this.methodDescriptorRegisterForEvent);
  }

  methodDescriptorCancelMyRegistration = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/CancelMyRegistration',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.CancelMyRegistrationRequest,
    events_v1_event_pb.CancelMyRegistrationResponse,
    (request: events_v1_event_pb.CancelMyRegistrationRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.CancelMyRegistrationResponse.deserializeBinary
  );

  cancelMyRegistration(
    request: events_v1_event_pb.CancelMyRegistrationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.CancelMyRegistrationResponse>;

  cancelMyRegistration(
    request: events_v1_event_pb.CancelMyRegistrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.CancelMyRegistrationResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.CancelMyRegistrationResponse>;

  cancelMyRegistration(
    request: events_v1_event_pb.CancelMyRegistrationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.CancelMyRegistrationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/CancelMyRegistration',
        request,
        metadata || {},
        this.methodDescriptorCancelMyRegistration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/CancelMyRegistration',
    request,
    metadata || {},
    this.methodDescriptorCancelMyRegistration);
  }

  methodDescriptorGetMyRegistration = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/GetMyRegistration',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.GetMyRegistrationRequest,
    events_v1_event_pb.GetMyRegistrationResponse,
    (request: events_v1_event_pb.GetMyRegistrationRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.GetMyRegistrationResponse.deserializeBinary
  );

  getMyRegistration(
    request: events_v1_event_pb.GetMyRegistrationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.GetMyRegistrationResponse>;

  getMyRegistration(
    request: events_v1_event_pb.GetMyRegistrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.GetMyRegistrationResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.GetMyRegistrationResponse>;

  getMyRegistration(
    request: events_v1_event_pb.GetMyRegistrationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.GetMyRegistrationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/GetMyRegistration',
        request,
        metadata || {},
        this.methodDescriptorGetMyRegistration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/GetMyRegistration',
    request,
    metadata || {},
    this.methodDescriptorGetMyRegistration);
  }

  methodDescriptorListEventRegistrations = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/ListEventRegistrations',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.ListEventRegistrationsRequest,
    events_v1_event_pb.ListEventRegistrationsResponse,
    (request: events_v1_event_pb.ListEventRegistrationsRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.ListEventRegistrationsResponse.deserializeBinary
  );

  listEventRegistrations(
    request: events_v1_event_pb.ListEventRegistrationsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.ListEventRegistrationsResponse>;

  listEventRegistrations(
    request: events_v1_event_pb.ListEventRegistrationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.ListEventRegistrationsResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.ListEventRegistrationsResponse>;

  listEventRegistrations(
    request: events_v1_event_pb.ListEventRegistrationsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.ListEventRegistrationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/ListEventRegistrations',
        request,
        metadata || {},
        this.methodDescriptorListEventRegistrations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/ListEventRegistrations',
    request,
    metadata || {},
    this.methodDescriptorListEventRegistrations);
  }

  methodDescriptorUpdateEventRegistrationStatus = new grpcWeb.MethodDescriptor(
    '/events.v1.EventService/UpdateEventRegistrationStatus',
    grpcWeb.MethodType.UNARY,
    events_v1_event_pb.UpdateEventRegistrationStatusRequest,
    events_v1_event_pb.UpdateEventRegistrationStatusResponse,
    (request: events_v1_event_pb.UpdateEventRegistrationStatusRequest) => {
      return request.serializeBinary();
    },
    events_v1_event_pb.UpdateEventRegistrationStatusResponse.deserializeBinary
  );

  updateEventRegistrationStatus(
    request: events_v1_event_pb.UpdateEventRegistrationStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<events_v1_event_pb.UpdateEventRegistrationStatusResponse>;

  updateEventRegistrationStatus(
    request: events_v1_event_pb.UpdateEventRegistrationStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.UpdateEventRegistrationStatusResponse) => void): grpcWeb.ClientReadableStream<events_v1_event_pb.UpdateEventRegistrationStatusResponse>;

  updateEventRegistrationStatus(
    request: events_v1_event_pb.UpdateEventRegistrationStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: events_v1_event_pb.UpdateEventRegistrationStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/events.v1.EventService/UpdateEventRegistrationStatus',
        request,
        metadata || {},
        this.methodDescriptorUpdateEventRegistrationStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/events.v1.EventService/UpdateEventRegistrationStatus',
    request,
    metadata || {},
    this.methodDescriptorUpdateEventRegistrationStatus);
  }

}

